import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    const finish = async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        applySession(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/my-bookings", { replace: true });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/signin?error=google", { replace: true });
      }
    };
    finish();
  }, [applySession, navigate]);

  return <div className="min-h-screen grid place-items-center text-slate-500">Signing you in…</div>;
}
